// Imported by app/metadata.ts, app/structured-data.tsx and the home hero so
// the meta tags, the JSON-LD graph and the page cannot drift. Problem first,
// industries by name; never lead with "AI". Descriptions 70–160 characters.

export const HOME_TITLE = 'Hear from every crew, the same day';

export const HOME_DESCRIPTION =
  'Your crews know first. Tessa checks in with hotel, construction and plant teams by call or WhatsApp, in their language, and routes blockers the same day.';

export const ENTITY_SENTENCE =
  'Tessa, by Apprendo, is an AI that checks in with every person on your team by phone, WhatsApp, SMS, Slack or email, in English, Spanish or French, and tells leaders what’s blocking work the same day.';

export const MARKETS_LINE = 'Built for teams across the US, Mexico and Canada.';
